import validate from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/middleware/auth.ts"),
  protected: () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/middleware/protected.ts"),
  "tv-auth": () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/middleware/tvAuth.ts"),
  "tv-protected": () => import("/home/gitlab-runner/builds/KtsZsFfZK/0/nprojects/sedna-main/middleware/tvProtected.ts")
}